export default "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAMAAAADCAIAAADZSiLoAAAAF0lEQVR4nGNgYPjP8J/hPwMDEwMMIFgASw8DAlKkj0AAAAAASUVORK5CYII="